import React from 'react';
import { Logout } from '../Logout';
import config from '../../../../config.json';
import { useEffect, useState } from 'react';

const expiryTime = config.TOKEN_EXPIRY_MIN * 60 * 1000; // Expiry time in milliseconds

export default function TokenExpiry() {
  const [isLogout, setIsLogout] = useState(false);
  
  useEffect(() => {
    const checkLoginExpiration = () => {
      const loginTimestamp = localStorage.getItem('timestamp');
      
      if (loginTimestamp) {
        const elapsedSinceLogin = Date.now() - parseInt(loginTimestamp, 10);
        if (elapsedSinceLogin > expiryTime) {
          
          localStorage.setItem('sessionTimeoutMessage', 'Your Session has Expired');
          localStorage.removeItem('timestamp');
	  setIsLogout(true);
	  //alert("Your Session is Timed Out");
        }
      }
    };

    const intervalId = setInterval(checkLoginExpiration, 30000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      {isLogout ? <Logout /> : ''}
    </>
  );
}
